import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Image from "next/image";
import React from "react";

export interface LogoObject {
    url: string;
    alt: string;
    width: number;
    height: number;
}

const clientLogosData: LogoObject[] = [
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-1.png", alt: "award-1", width: 498, height: 374 },
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-2.png", alt: "award-2", width: 498, height: 374 },
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-3.png", alt: "award-3", width: 498, height: 374 },
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-4.png", alt: "award-4", width: 498, height: 374 },
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-5.png", alt: "award-5", width: 498, height: 374 },
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-6.png", alt: "award-6", width: 498, height: 374 },
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-7.png", alt: "award-7", width: 498, height: 374 },
    { url: "https://assets.gallabox.com/gb-home/partner-program/award-8.png", alt: "award-8", width: 498, height: 374 },
];

const AwardSection: React.FC<{ logos?: LogoObject[] }> = ({ logos }) => {
    const animation = { duration: 10000, easing: (t: any) => t };

    const [desktopSliderRef] = useKeenSlider({
        slides: { perView: 6, spacing: 40 },
        loop: true,
        drag: true,
        created(s) {
            s.moveToIdx(5, true, animation);
        },
        updated(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
        animationEnded(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
    });

    const [mobileSliderRef] = useKeenSlider({
        slides: { perView: "auto", spacing: 20 },
        loop: true,
        drag: true,
        created(s) {
            s.moveToIdx(5, true, animation);
        },
        updated(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
        animationEnded(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
    });

    return (
        <>
            <div
                className="lg:block  hidden"
                style={{
                    background: "linear-gradient(265deg, #396AFF -7.73%, #00238D 61.31%, #000 102.16%)",
                    height: "auto",
                }}
            >
                <h2 className="text-white text-4xl font-semibold pt-10 text-center" style={{ fontFamily: "Degular Display" }}>
                    2025 partner awards
                </h2>
                <p className="text-white text-base font-semibold pt-2 text-center" style={{ fontFamily: "Degular Display" }}>
                    Celebrating our top-performing partners
                </p>
                <div ref={desktopSliderRef} className="keen-slider sliderparent-dark mt-10 pb-10">
                    {(logos ? logos : clientLogosData).map((e, i) => (
                        <div
                            className={`keen-slider__slide slider-card number-slide${i} flex items-center justify-center`}
                            style={{ minWidth: `${e.width}px !important`, width: `${e.width}px !important`, maxWidth: `${e.width}px !important`, height: "auto" }}
                            key={i}
                        >
                            <div className="flex items-center rounded-lg">
                                <Image width={e.width} height={e.height} src={e.url} alt={e.alt} className="rounded-lg" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div
                className="block lg:hidden"
                style={{
                    background: "linear-gradient(265deg, #396AFF -7.73%, #00238D 61.31%, #000 102.16%)",
                    height: "auto",
                }}
            >
                <h2 className="text-white text-lg font-semibold pt-10 text-center" style={{ fontFamily: "Degular Display" }}>
                    2025 partner awards
                </h2>
                <p className="text-white text-base font-semibold pt-2 text-center" style={{ fontFamily: "Degular Display" }}>
                    Celebrating our top-performing partners
                </p>
                <div ref={mobileSliderRef} className="keen-slider sliderparent-dark mt-10 pb-10">
                    {(logos ? logos : clientLogosData).map((e, i) => (
                        <div
                            className={`keen-slider__slide slider-card number-slide${i} flex items-center justify-center`}
                            style={{ minWidth: "80px !important", width: "80px !important", maxWidth: "80px !important", height: "80px !important", flexShrink: 0 }}
                            key={i}
                        >
                            <div className="flex items-center" style={{ width: "80px", height: "80px" }}>
                                <Image width={200} height={200} src={e.url} alt={e.alt} className="rounded-sm" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
                            </div>
                        </div>
                    ))}
                </div>
                <style jsx>{`
                    @media (max-width: 1024px) {
                        .keen-slider__slide {
                            min-width: 80px !important;
                            width: 80px !important;
                            max-width: 80px !important;
                        }
                    }
                `}</style>
            </div>
        </>
    );
};

export default AwardSection;
